import { Button } from 'react-bootstrap';
import { FaLine } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { useLineLoginUrlMutation } from '../slices/usersApiSlice';

// "使用 LINE 登入 / 註冊" button, shared by LoginScreen and RegisterScreen.
// LINE Login creates the account on first sign-in, so one button covers both.
//
// Why a mutation + window.location instead of <a href="/api/...">?
// The CRA dev proxy only forwards fetch/XHR. A full-page navigation to /api
// would get index.html. So: fetch the URL (server also sets the state cookie),
// then send the browser to LINE.
const LineLoginButton = ({ redirect = '/', label = '使用 LINE 登入' }) => {
  const [getLineUrl, { isLoading }] = useLineLoginUrlMutation();

  const clickHandler = async () => {
    try {
      const { url } = await getLineUrl({ redirect }).unwrap();
      window.location.assign(url);
    } catch (err) {
      toast.error(err?.data?.message || err.error || 'LINE 登入暫時無法使用');
    }
  };

  return (
    <Button
      type="button"
      className="btn-line w-100"
      onClick={clickHandler}
      disabled={isLoading}
    >
      <FaLine aria-hidden="true" />
      {label}
    </Button>
  );
};

export default LineLoginButton;
